/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterSubMenuAddPost } from '../fn/sub-menu/api-master-sub-menu-add-post';
import { ApiMasterSubMenuAddPost$Params } from '../fn/sub-menu/api-master-sub-menu-add-post';
import { apiMasterSubMenuDeleteGet } from '../fn/sub-menu/api-master-sub-menu-delete-get';
import { ApiMasterSubMenuDeleteGet$Params } from '../fn/sub-menu/api-master-sub-menu-delete-get';
import { apiMasterSubMenuEditPost } from '../fn/sub-menu/api-master-sub-menu-edit-post';
import { ApiMasterSubMenuEditPost$Params } from '../fn/sub-menu/api-master-sub-menu-edit-post';
import { apiMasterSubMenuGetActiveGet } from '../fn/sub-menu/api-master-sub-menu-get-active-get';
import { ApiMasterSubMenuGetActiveGet$Params } from '../fn/sub-menu/api-master-sub-menu-get-active-get';
import { apiMasterSubMenuGetAllGet } from '../fn/sub-menu/api-master-sub-menu-get-all-get';
import { ApiMasterSubMenuGetAllGet$Params } from '../fn/sub-menu/api-master-sub-menu-get-all-get';
import { apiMasterSubMenuGetByCriteriaPost } from '../fn/sub-menu/api-master-sub-menu-get-by-criteria-post';
import { ApiMasterSubMenuGetByCriteriaPost$Params } from '../fn/sub-menu/api-master-sub-menu-get-by-criteria-post';
import { Int32ApiRespModel } from '../models/int-32-api-resp-model';
import { SubMenu } from '../models/sub-menu';
import { SubMenuApiRespModel } from '../models/sub-menu-api-resp-model';

@Injectable({ providedIn: 'root' })
export class SubMenuService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterSubMenuAddPost()` */
  static readonly ApiMasterSubMenuAddPostPath = '/api/Master/SubMenu/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterSubMenuAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterSubMenuAddPost$Response(params?: ApiMasterSubMenuAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubMenuApiRespModel>> {
    return apiMasterSubMenuAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterSubMenuAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterSubMenuAddPost(params?: ApiMasterSubMenuAddPost$Params, context?: HttpContext): Observable<SubMenuApiRespModel> {
    return this.apiMasterSubMenuAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubMenuApiRespModel>): SubMenuApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterSubMenuEditPost()` */
  static readonly ApiMasterSubMenuEditPostPath = '/api/Master/SubMenu/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterSubMenuEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterSubMenuEditPost$Response(params?: ApiMasterSubMenuEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubMenuApiRespModel>> {
    return apiMasterSubMenuEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterSubMenuEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterSubMenuEditPost(params?: ApiMasterSubMenuEditPost$Params, context?: HttpContext): Observable<SubMenuApiRespModel> {
    return this.apiMasterSubMenuEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubMenuApiRespModel>): SubMenuApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterSubMenuDeleteGet()` */
  static readonly ApiMasterSubMenuDeleteGetPath = '/api/Master/SubMenu/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterSubMenuDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterSubMenuDeleteGet$Response(params?: ApiMasterSubMenuDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiRespModel>> {
    return apiMasterSubMenuDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterSubMenuDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterSubMenuDeleteGet(params?: ApiMasterSubMenuDeleteGet$Params, context?: HttpContext): Observable<Int32ApiRespModel> {
    return this.apiMasterSubMenuDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Int32ApiRespModel>): Int32ApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterSubMenuGetAllGet()` */
  static readonly ApiMasterSubMenuGetAllGetPath = '/api/Master/SubMenu/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterSubMenuGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterSubMenuGetAllGet$Response(params?: ApiMasterSubMenuGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubMenu>>> {
    return apiMasterSubMenuGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterSubMenuGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterSubMenuGetAllGet(params?: ApiMasterSubMenuGetAllGet$Params, context?: HttpContext): Observable<Array<SubMenu>> {
    return this.apiMasterSubMenuGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubMenu>>): Array<SubMenu> => r.body)
    );
  }

  /** Path part for operation `apiMasterSubMenuGetActiveGet()` */
  static readonly ApiMasterSubMenuGetActiveGetPath = '/api/Master/SubMenu/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterSubMenuGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterSubMenuGetActiveGet$Response(params?: ApiMasterSubMenuGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubMenu>>> {
    return apiMasterSubMenuGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterSubMenuGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterSubMenuGetActiveGet(params?: ApiMasterSubMenuGetActiveGet$Params, context?: HttpContext): Observable<Array<SubMenu>> {
    return this.apiMasterSubMenuGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubMenu>>): Array<SubMenu> => r.body)
    );
  }

  /** Path part for operation `apiMasterSubMenuGetByCriteriaPost()` */
  static readonly ApiMasterSubMenuGetByCriteriaPostPath = '/api/Master/SubMenu/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterSubMenuGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterSubMenuGetByCriteriaPost$Response(params?: ApiMasterSubMenuGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubMenu>>> {
    return apiMasterSubMenuGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterSubMenuGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterSubMenuGetByCriteriaPost(params?: ApiMasterSubMenuGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<SubMenu>> {
    return this.apiMasterSubMenuGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubMenu>>): Array<SubMenu> => r.body)
    );
  }

}
